// extracted by mini-css-extract-plugin
module.exports = {"settings-list":"style_settings-list__i3vNl"};